import { Input, useColorModeValue } from '@chakra-ui/react'
import React from 'react'

type Props = {
    value?: string,
}

const CardField : React.FC<Props> = ({value}) => {
    const bg = useColorModeValue('gray.200', 'gray.600');
    const textColor = useColorModeValue('gray.500', 'gray.400');

  return (
    <Input bg={bg} type={'text'} color={textColor} style={{textAlign: "center", border: "none"}} readOnly value={value || ""} />
  )
}

export default CardField